import styled from "styled-components";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";

export const StyledTable = styled(Table)`
  font-family: "Lato-Semibold" !important;
  border-radius: 4px;
  background-color: rgba(155, 155, 155, 0.17) !important;

  @media only screen and (max-width: 959.95px) {
    &.dynamic-box {
      text-align: center;
    }
  }

  -webkit-animation: fadein 0.7s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 0.7s; /* Firefox < 16 */
  -ms-animation: fadein 0.7s; /* Internet Explorer */
  -o-animation: fadein 0.7s; /* Opera < 12.1 */
  animation: fadein 0.7s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const StyledCell = styled(TableCell)`
  font-family: "Lato-Semibold" !important;
  display: inline-block;
  font-weight: normal !important;
  border: none !important;
`;

export const StyledTitle = styled(StyledCell)`
  padding: 15px 10px 15px 28px !important;
  line-height: 29px;
  letter-spacing: initial;

  span {
    font-size: 21px !important;

    @media only screen and (max-width: 959.95px) {
      font-size: 20px !important;
    }
  }

  
  &.dynamic-box {
    padding: 35px 10px 35px 28px !important;

    span {
      font-size: 24px !important;
    }
  }

  @media only screen and (max-width: 959.95px) {
    &.dynamic-box {
      display: block !important;
      float: none;
      text-align: center;
      padding: 30px 10px 10px !important;
    }
  }
`;

export const StyledValue = styled(StyledCell)`
  text-align: right !important;
  float: right;
  font-size: 18px !important;
  padding: 15px 28px 15px 0px !important;
  position: relative;

  span {
    font-size: 27px;
    margin-right: -2px;
    line-height: 35px;
  }

  &.dynamic-box {
    font-size: 23px !important;
    min-width: 170px;
    padding: 35px 28px 35px 0px !important;

    span {
      font-size: 29px;
      line-height: 1.43;
    }
  }

  @media only screen and (max-width: 959.95px) {
    font-size: 16px !important;
    span {
      font-size: 21px !important;
    }

    &.dynamic-box {
      font-size: 25px !important;
      span {
        font-size: 30px !important;
      }
      display: block !important;
      float: none;
      text-align: center !important;
      padding: 10px 30px 30px !important;
    }
  }
`;
